<!-- this div is needed, because the esri widget needs it -->
<arcgis-search #searchWidget include-default-sources-disabled class="search"></arcgis-search>
